<template>
  <div class="settingsCard contrainer-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-irish-date">Settings</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-tabs class="settingsTabs mt-3">
        <b-tab
          title="Notifications"
          active
          title-link-class="btn btn-bumblebee btn-mid btn-tab btn-mid-primary"
        >
          <MIDSettingsNotifications />
        </b-tab>
        <b-tab
          title="SMS"
          title-link-class="btn btn-bumblebee btn-mid btn-tab btn-mid-primary"
        >
          <MIDSettingsSMS />
        </b-tab>
        <!-- <template #tabs-start>
        <li role="presentation" class="nav-item align-self-center">
          <button class="btn btn-bumblebee btn-mid btn-tab nav-link btn-mid-primary m-0"
          @click="clickSaveChanges">
           Save Changes
          </button>
        </li>
      </template> -->
      </b-tabs>
    </div>
  </div>
</template>


<script>
import MIDSettingsSMS from "./SMS.vue";
 import MIDSettingsNotifications from "./Notifications.vue";

export default {
  name: "MIDSettings",
  components: { MIDSettingsSMS , MIDSettingsNotifications},
  data() {
    return {};
  },
  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/components/my_irish_date/settings/Index.vue